

let en: ITranslationProps;
en = {
  i18n: {
    Alarm: {
      COUNTERMAXEXCEEDED: 'Counter exceeded',
      INPUTALARMBEGIN: 'Alarm',
      INPUTALARMEND: 'Recovery',
      POWERSUPPLYBATTERYDOWN: 'Power Supply Battery down',
      POWERSUPPLYBATTERYUP: 'Power Supply Battery up',
      POWERSUPPLYSECTORDOWN: 'Power Supply Sector down',
      POWERSUPPLYSECTORUP: 'Power Supply Sector up',
      SENSORDEFAULT: 'Sensor default',
      SENSORDEFAULTEND: 'End of sensor default',
      THRESHOLDDOWN: 'Lower threshold',
      THRESHOLDOK: 'Back to normal',
      THRESHOLDUP: 'High threshold',
      title: 'Alarm',
    },
    ChangePassword: {
      change: 'Change',
      newPassword: 'New password',
      oldPassword: 'Old password',
      title: 'Password',
    },
    Common: {
      alert: 'Alert by',
      confirmCancel: 'Are you sure you want to discard your changes ?',
      day_0: 'S',
      day_1: 'M',
      day_2: 'T',
      day_3: 'W',
      day_4: 'T',
      day_5: 'F',
      day_6: 'S',
      email: 'Email',
      errors: {
        401: 'Invalid email or password',
        500: 'Server error, retry later',
        DEVICE_CODE_NOT_FOUND: 'Unknonw code',
        DEVICE_NOT_FOUND: 'Please wait for the Smart TX to be connected to Cloud',
        ERROR: 'An error occured',
        ERROR_UPDATING_PASSWORD: 'Error in changing password',
        NETWORK: 'Network error, check your connectivity',
        OUTPUT_CHANGE_NOT_ALLOWED: 'Output change only allowed in manuel mode',
        TEST_TOO_EARLY: 'You have to wait 1 minute betwwen two tests',
        TIMEOUT: 'Timeout sending command to the Smart TX',
        UNKNOW_COMMAND: 'Command cant\' be processed',
        USER_EXISTS: 'Email already in used',
        USER_NOT_EXISTS: 'Check your email',
        email: 'Email is incorrect',
        invalidField: 'Field is invalid',
        password: 'Password must be at least 4 characters',
        phoneNumber: 'Phone number is invalid',
        testSent: 'Test will be sent soon',
      },
      mode: 'Operating mode',
      no: 'No',
      password: 'Password',
      phone: 'Phone number',
      unit: 'Unit',
      units: {
        hour: 'Hour',
        kilowatt: 'KiloWatt',
        liter: 'Litre',
        meter: 'Mètre cube',
        minute: 'Minute',
        second: 'Second',
        watt: 'Watt',
      },
      yes: 'Yes',
    },

    DashBoard: {
      noSensor: 'No sensor',
      offLine: 'Off line',
      waitForSync: 'Please wait before syncing again',
    },
    Home: {
      confirmDelete: 'Are you sure you want to delete this site ?',
      home: 'Home',
      smartremote: 'Smart TX',
    },
    Input: {
      backToNormal: 'Gestion du retour à la normale',
      counterMax: 'Valeur max journalière',
      counterMaxShort: 'MAX',
      counterTotal: 'Totalisateur',
      counterTotalShort: 'TOTAL',
      counterWeight: 'Poids de l\'impulsion',
      counterWeightShort: 'WEIGTH',
      disparitionValue: 'Intégration à la disparition',
      disparitionValueShort: 'INTEGRATION',
      integrationValue: 'Intégration à l\'apprition',
      integrationValueShort: 'INTEGRATION',
      label: 'Nom',
      mode_0: 'Mode Alarme',
      mode_1: 'Mode On / Off',
      mode_2: 'Comptage Impulsionnel',
      way: 'Sens de fonctionnement',
      way_0: 'Normalement Ouvert',
      way_1: 'Normalement Fermé',
    },
    LogEvent: {
      LOG_0: "Please wait...",
      LOG_10: "Starting the Smart TX. M1 software version:",
      LOG_100: "Unable to perform UPNP redirection without IP address",
      LOG_1000: "The Smart TX works in failover mode on",
      LOG_1001: "The Smart TX works in VOIP gateway mode",
      LOG_1002: "Smart TX works in GSM gateway mode",
      LOG_1003: "Smart TX works in unknown mode",
      LOG_1004: "The Smart TX works in fail-over mode on VOIP because the GSM modem is absent",
      LOG_1005: "Number of hours before restarting the GSM modem:",
      LOG_1006: "No number set for SMS notifications",
      LOG_1008: "Cyclic test of notifications",
      LOG_101: "UPNP redirection successfully completed",
      LOG_1014: "Call ended",
      LOG_1015: "Incoming call completed",
      LOG_1016: "GSM modem present",
      LOG_1019: "Incoming call",
      LOG_102: "Unable to perform UPNP redirection:",
      LOG_1025: "Start of alarm on the entrance",
      LOG_1026: "End of the alarm on the entrance",
      LOG_1027: "Activation of the output",
      LOG_1028: "Disabling the output",
      LOG_1029: "Start of the impulse on the exit",
      LOG_1030: "End of the impulse on the exit",
      LOG_1050: "LAN loss",
      LOG_1051: "Loss of the GSM network",
      LOG_1060: "LAN network recovery",
      LOG_1061: "GSM network recovery",
      LOG_1070: "LAN available",
      LOG_1071: "GSM connection established",
      LOG_1080: "Time setting detected, reloading the cyclic test",
      LOG_1083: "A new message has just been received",
      LOG_1084: "Incorrect SMS code provided",
      LOG_1085: "Request to change the status of the received output",
      LOG_1086: "Unrecognized function request",
      LOG_1087: "Unable to delete received SMS",
      LOG_1088: "Can not call without recipient number",
      LOG_1089: "Completed call due to maximum duration reached",
      LOG_1090: "Start on Input ",
      LOG_1091: "Stop on the Input ",
      LOG_1092: "Falling tension",
      LOG_1093: "Mode configured for this number:",
      LOG_1098: "Emergency extinguishment",
      LOG_1099: "Return of power supply",
      LOG_11: "Trendy network cable",
      LOG_1100: "Received frame without STX",
      LOG_1101: "Analogue line present",
      LOG_1102: "Analog line absent",
      LOG_1103: "Taking the line by the equipment",
      LOG_1104: "Return of the line by the equipment",
      LOG_1105: "Caller's number",
      LOG_1106: "M2 Software Version:",
      LOG_1107: "Factory return requested",
      LOG_1108: "Power supply voltage too low",
      LOG_1109: "Unknown action requested",
      LOG_1110: "Unexpected frame received",
      LOG_1111: "Restart after power failure",
      LOG_1112: "Restart after reset software M1",
      LOG_1113: "Restart after reset software M2",
      LOG_1114: "Restarting due to an unknown cause",
      LOG_1115: "Restart suite hard reset software M2",
      LOG_1200: "No IP address",
      LOG_1201: "IP address detected",
      LOG_1202: "Can not get an IP address",
      LOG_1203: "Trendy network cable",
      LOG_1204: "Disconnected network cable",
      LOG_13: "Sound card not detected",
      LOG_1300: "Received frame",
      LOG_1301: "Invalid frame received",
      LOG_1302: "Unable to open the serial link",
      LOG_1303: "Sending the frame",
      LOG_14: "Serious error in creating the thread",
      LOG_1400: "Email successfully sent to",
      LOG_1401: "Error in sending mail",
      LOG_15: "Serious error in thread association",
      LOG_1500: "Language file not found",
      LOG_1501: "Error reading language file",
      LOG_1900: 'Unable to open serial link with GSM',
      LOG_1901: "Modem configured",
      LOG_1902: "Modem not configured",
      LOG_1903: "Not registered on the GSM network, is not currently looking for another operator",
      LOG_1904: "Registered on the GSM network",
      LOG_1905: "Not registered on the GSM network, search for an operator in progress",
      LOG_1906: "Registered on the GSM network refused",
      LOG_1907: "Recording status on the unknown GSM network",
      LOG_1908: "Registered on the GSM network (roaming)",
      LOG_1909: "Recording status on the unknown GSM network",
      LOG_1910: "Unable to get registration status on the GSM network",
      LOG_1911: "Rejection of the incoming GSM call",
      LOG_1912: "SIM card present",
      LOG_1913: "Default with the SIM card",
      LOG_1914: "PIN code OK",
      LOG_1915: "Incorrect PIN code",
      LOG_1916: "PIN code successfully deactivated",
      LOG_1917: "Can not disable PIN",
      LOG_1918: "Unable to make the call without being registered on the network",
      LOG_1919: "Can not send SMS without being registered on the network",
      LOG_1920: "SMS successfully sent to",
      LOG_1921: "An error occurred while sending the SMS",
      LOG_1922: "List of operators successfully recovered",
      LOG_1923: "An error occurred while searching for operators",
      LOG_1924: "An error occurred while retrieving the state of the SIM card",
      LOG_1925: "Rejection of the incoming GSM call as the equipment holds the line",
      LOG_1926: "GSM modem not ready to process the order",
      LOG_1927: "An error occurred while reading the received SMS",
      LOG_1928: "GSM modem not connected to the data network",
      LOG_1929: "Sending the order",
      LOG_1930: "GSM link not established or disconnected (ex: hung from the remote)",
      LOG_1931: "GSM recipient busy",
      LOG_1932: "Manual selection of the operator:",
      LOG_1933: "Start of GSM modem initialization",
      LOG_1934: "End of GSM modem initialization",
      LOG_200: "Configuration file not present",
      LOG_2000: "Web: Changing the network configuration",
      LOG_2001: "Web: Changing the UPNP Configuration",
      LOG_2002: "Web: Changing the whitelist configuration",
      LOG_2004: "Web: changing the access configuration",
      LOG_2005: "Web: Changing the recipient configuration",
      LOG_2006: "Web: Changing the notification configuration",
      LOG_2007: "Web: changing the input configuration",
      LOG_2008: "Web: Changing the output configuration",
      LOG_2009: "Web: Changing the cyclic test configuration",
      LOG_201: "Error in reading the configuration:",
      LOG_2010: "Web: Modifying the GSM Modem Configuration",
      LOG_2011: "Web: sending an order to the GSM Modem",
      LOG_2012: "Web: sending an order to the MC",
      LOG_2013: "Web: request for deletion of the PIN",
      LOG_2014: "Web: Changing the language configuration",
      LOG_2015: "Web: Changing the SMTP configuration",
      LOG_2016: "Web: Changing the configuration of the operating mode",
      LOG_2018: "Web: changing the state of an output",
      LOG_2019: "Web: successful user login",
      LOG_202: "Failed to load the configuration to restore:",
      LOG_2020: "Web: successful administrator login",
      LOG_2021: "Web: failed connection",
      LOG_2022: "Web: restart requested",
      LOG_2023: "Web: Software update requested",
      LOG_2024: "Web: Restore Requested Factory Settings",
      LOG_2025: "Web: request to restart the GSM modem",
      LOG_2026: "Web: Restoring the requested configuration",
      LOG_2027: "Web: Invalid configuration file",
      LOG_2028: "Web: restored configuration",
      LOG_2029: "Web: recipient test",
      LOG_2030: "Web: Changing the configuration of the SMS secret code",
      LOG_2031: "Web: new firmware successfully downloaded, it will be applied",
      LOG_2032: "Web: the firmware is not honest and will not be applied",
      LOG_2034: "Web: changing the audio configuration",
      LOG_2036: "Web: Changing the configuration of the listening application",
      LOG_2037: "Web: modification of the protocol for the webserver",
      LOG_2038: "Web: Changing the configuration of the transmission application",
      LOG_2039: "Web: Changing the GPRS configuration",
      LOG_2040: "Data:",
      LOG_2041: "Web: the firmware is not a valid firmware",
      LOG_2042: "Web: the firmware has been downloaded successfully and will be applied",
      LOG_2043: "Web: Recipient Test:",
      LOG_2045: "Web: refresh of the public IP address",
      LOG_2047: "Web: changing the configuration of the probes",
      LOG_2048: "Web: manual selection of the operator",
      LOG_2049: "Web: changing the thermostat mode",
      LOG_2050: "Web: changing the thermostat schedule",
      LOG_2300: "New number added in transparent mode:",
      LOG_2301: "The following network will now be used:",
      LOG_2302: "No network available to transmit",
      LOG_2303: "Back on the network configured as the backbone",
      LOG_2304: "GSM network connectivity",
      LOG_2305: "Can not change the status of an output that is not in a remote control",
      LOG_2306: "Can not establish communication with",
      LOG_2307: "Can not establish communication because",
      LOG_2308: "Temperature alarm too high",
      LOG_2309: "Alarm on temperature too low",
      LOG_2310: "End of alarm on exceeding temperature threshold",
      LOG_2311: "Time setting via",
      LOG_2312: "Exceeding the daily value of the meter",
      LOG_2313: "Thermostat: activation of the output",
      LOG_2314: "Thermostat: deactivation of the output",
      LOG_2315: "Fault on the temperature sensor",
      LOG_2316: "End of fault on the temperature probe",
      LOG_2317: "Thermostat: change of mode according to schedule:",
      LOG_2318: "Thermostat: change of mode from the keyboard:",
      LOG_2400: "Connected to the cloud",
      LOG_2401: "Error trying to connect to the cloud",
      LOG_2402: "Disconnected from the cloud",
      LOG_2403: "Application: update application for firmware",
      LOG_2404: "Application: synchronization request",
      LOG_2405: "Application: change of state of the output",
      LOG_2406: "Application: Changing the probe configuration",
      LOG_2407: "Application: Changing the output configuration",
      LOG_2408: "Application: Changing the configuration of the input",
      LOG_2409: "Application: recipient test",
      LOG_2410: "Application: enresgistration of recipients",
      LOG_2411: "Application: Regeneration scheduling",
      LOG_2412: "Application: data:",
      LOG_300: "Media not managed for notification",
      LOG_301: "Conditions are not yet required for sending the type message",
      LOG_400: "MC idle time exceeded",
      title: 'History',
    },
    Login: {
      email: 'Email',
      login: 'Login',
      lostPassword: 'Lost password ?',
      notYetMemeber: 'Not yet memeber',
      password: 'Password',
      register: 'Register',
      rememberMe: 'Remember Me',
    },
    LostPassword: {
      email: 'Email Address',
      send: 'Send me a new password',
      title: 'Lost password',
    },
    Media: {
      alarm: 'Alarms',
      mail: 'Email',
      notification: 'Evénements systèmes',
      push: 'Notif PUSH',
      sms: 'SMS',
    },
    Menu: {
      alarm: 'Alarms',
      habilitedUsers: 'Habilited users',
      help: 'Help',
      logEvent: 'History',
      password: 'Change password',
      push: 'Receive Push',
      recipient: 'Recipient list',
      signout: 'Sign out',
      site: 'Site list',
      sms: 'SMS control',
      status: 'System information',
    },
    Output: {
      label: 'Name',
      mode_0: 'On / Off',
      mode_1: 'Pulse',
      temporisationUnit: 'Unit',
      temporisationValue: 'Timeout',
      temporisationValueShort: 'TIMEOUT',
    },
    RecipientList: {
      confirmNotChecked: 'Are you sure you don\'t want to check this recipient',
      maxTenInputAlarm: 'You can\'t have more than 10 recipient for alarms',
      maxTenTechnicalAlarm: 'You can\'t have more than 10 recipient for notification',
      test: 'Send test messages',
      title: 'Recipients',
      titleEdit: 'Recipient',
    },
    Register: {
      confirmation: 'Confirm password',
      errors: {
        confirmation: 'Confirmation must be identical to password',
      },
      register: 'REGISTER',
      title: "Register",
    },
    Schedule: {
      dateTimeCancel: 'Cancel',
      dateTimeCancelButtonLabel: 'Cancel',
      dateTimeDoneButtonLabel: 'Done',
      dateTimeOk: 'Ok',
      dateTimeTitle: 'Choose a time',
      errorDayMandatory: 'Day is mandatory for every schedule',
      errorStartAfterEnd: 'Start time must be before end time',
      maxSchedule: 'Schedule are limited to 35',
      title: 'Schedule',
    },
    SiteAdd: {
      code: 'Code',
      errorCode: 'Code format is incorrect',
      errorName: 'Name  format is incorrect',
      name: 'Name',
      title: 'Add',
    },
    SiteEdit: {
      errorName: 'Name  format is incorrect',
      name: 'Name',
      title: 'Edit',
    },
    Sms: {
      apnConnect: 'Apply APN Settings',
      apnGet: 'Get APN Parameters',
      apnPassword: 'Set APN Password',
      apnServer: 'Set APN',
      apnUser: 'Set APN User',
      changePassword: 'Change secret code',
      groupAction: 'Command',
      groupApn: 'APN & Code',
      groupQuery: 'Query',
      groupThermostat: 'Thermostat',
      in1: 'Input 1 state',
      in2: 'Input 2 state',
      info: 'System informations',
      out1off: 'OUT1 OFF',
      out1on: 'OUT1 ON',
      out2off: 'OUT2 OFF',
      out2on: 'OUT2 ON',
      phoneNumber: 'Smart TX Phone Number',
      temp1: 'Get Sensor 1 Temp',
      temp2: 'Get Sensor 2 Temp',
      thermostatDisable: 'Disable thermostat',
      thermostatMode: 'Current thermostat mode',
      title: 'SMS Pilot'
    },
    Status: {
      alreadyUptodate: 'Your Smart TX is already up to date',
      appVersion: 'App version',
      battery: 'Battery',
      battery_good: 'Charge OK',
      battery_medium: 'Charge medium',
      battery_poor: 'Charge down',
      battery_unknown: 'Not connected',
      connectionType: 'Type of connection',
      disconnected: 'Not connected',
      gsmNumber: 'SIM Phone Num',
      gsmOperator: 'Operator',
      ipAddress: 'IP Address',
      lastDate: 'Last data',
      m1Version: 'M1 Version',
      m2Version: 'M2 Version',
      mac: 'Mac address',
      remoteIp: 'Public IP',
      sector: 'External Power supply',
      title: 'Status',
      update: 'Update',
    },

    Temperature: {
      label: 'Name of the sensor',
      thermostat: 'Thermostat',
      thresholdCalibration: 'Correction (°C)',
      thresholdCalibrationShort: 'Correction (°C)',
      thresholdDelta: 'Delta reset (°C)',
      thresholdDeltaShort: 'Delta reset (°C)',
      thresholdDown: 'Threshold down (°C)',
      thresholdDownShort: 'Threshold down (°C)',
      thresholdNotCorrect: 'The up thresehold must be greater than the down thresehold increased by delta reset',
      thresholdUp: 'Threshold up (°C)',
      thresholdUpShort: 'Threshold up (°C)',
    },
    Thermostat: {
      modeComfort: 'Comfort',
      modeEco: 'Eco',
      modeFrost: 'Frost protection',
      modeOff: 'Use thermostat',
      modePlanning: 'Planning',
      planningNotAvailable: 'Planning is not available without time slot defined',
      setpointComfort: 'Comfort (°C)',
      setpointComfortShort: 'Comfort',
      setpointEco: 'Eco (°C)',
      setpointEcoShort: 'Eco',
      setpointFrost: 'Frost protection  (°C)',
      setpointFrostShort: 'Frost protection',
      setpointOrderError: 'Setpoint must be in increase order Frost, Eco, Comfort',
      title: 'Thermostat',
    },
    User: {
      lastConnection: 'Last Connection on',
      title: 'Users list',
    }
  }
};
let fr: ITranslationProps;
fr = {
  i18n: {
    Alarm: {
      COUNTERMAXEXCEEDED: 'Dépassement du compteur',
      INPUTALARMBEGIN: 'Alarme',
      INPUTALARMEND: 'Rétablissement',
      POWERSUPPLYBATTERYDOWN: 'Batterie déchargée',
      POWERSUPPLYBATTERYUP: 'Batterie chargée',
      POWERSUPPLYSECTORDOWN: 'Coupure de l\'alimentation',
      POWERSUPPLYSECTORUP: 'Retour de l\'alimentation',
      SENSORDEFAULT: 'Sonde en défaut',
      SENSORDEFAULTEND: 'Fin de défaut',
      THRESHOLDDOWN: 'Dépassement de seuil bas',
      THRESHOLDOK: 'Retour à la normale',
      THRESHOLDUP: 'Dépassement de seuil haut',
      title: 'Alarmes',
    },
    ChangePassword: {
      change: 'Modifier le mot de passe',
      newPassword: 'Nouveau mot de passe',
      oldPassword: 'Ancien mot de passe',
      title: 'Mot de passe',
    },
    Common: {
      alert: 'Alerter par',
      confirmCancel: 'Etes-vous sûr de vouloir annuler vos modifications ?',
      day_0: 'D',
      day_1: 'L',
      day_2: 'M',
      day_3: 'M',
      day_4: 'J',
      day_5: 'V',
      day_6: 'S',
      email: 'Email',
      errors: {
        401: 'Email ou mot de passe erroné',
        500: 'Le serveur a rencontré une erreur, veuillez réessayer',
        DEVICE_CODE_NOT_FOUND: 'Le code n\'est pas reconnu',
        DEVICE_NOT_FOUND: 'Merci d\'attendre que la Smart TX soit connectée au Cloud',
        ERROR: 'Une erreur s\'est produite',
        ERROR_UPDATING_PASSWORD: 'L\'ancien mot de passe ou le nouveau n\'est pas correct',
        NETWORK: 'Erreur réseau, vérifiez votre connexion',
        // NETWORK: 'Une erreur est survenue, veuillez réessayer ultérieurement',
        OUTPUT_CHANGE_NOT_ALLOWED: 'Changement non autorisé en mode planning',
        TEST_TOO_EARLY: 'Veuillez patienter 1 minute entre deux tests',
        TIMEOUT: 'La Smart TX a mis trop de temps à répondre',
        UNKNOW_COMMAND: 'La commande n\'a pas pu être traitée',
        USER_EXISTS: 'L\'adresse email est déjà utilisée',
        USER_NOT_EXISTS: 'Veuillez vérifier votre email',
        email: 'L\'adresse email est incorrecte',
        invalidField: 'Le champ est invalide',
        password: 'Ce champ doit faire au moins 4 caractères',
        phoneNumber: 'Le numéro de téléphone est incorrect',
        testSent: 'La demande de test a été prise en compte',
      },
      mode: 'Mode de fonctionnement',
      no: 'Non',
      password: 'Mot de passe',
      phone: 'Numéro de téléphone (SMS)',
      unit: 'Unité',
      units: {
        hour: 'Heure',
        kilowatt: 'KiloWatt',
        liter: 'Litre',
        meter: 'Mètre cube',
        minute: 'Minute',
        second: 'Seconde',
        watt: 'Watt',
      },
      yes: 'Oui'
    },

    DashBoard: {
      noSensor: 'Pas de sonde',
      offLine: 'Hors ligne',
      waitForSync: 'Veuillez patienter avant d\'effectuer une nouvelle demande',
    },
    Home: {
      confirmDelete: 'Etes-vous sûr de vouloir supprimer ce site ?',
      home: 'Accueil',
      smartremote: 'Smart TX',
    },
    Input: {
      backToNormal: 'Gestion du retour à la normale',
      counterMax: 'Valeur max journalière',
      counterMaxShort: 'MAX JOURNALIER',
      counterTotal: 'Totalisateur',
      counterTotalShort: 'TOTALISATEUR',
      counterWeight: 'Poids de l\'impulsion',
      counterWeightShort: 'POIDS',
      disparitionValue: 'Intégration à la disparition',
      disparitionValueShort: 'INTEGRATION',
      integrationValue: 'Intégration à l\'apprition',
      integrationValueShort: 'INTEGRATION',
      label: 'Nom',
      mode_0: 'Mode Alarme',
      mode_1: 'Mode On / Off',
      mode_2: 'Comptage Impulsionnel',
      way: 'Sens de fonctionnement',
      way_0: 'Normalement Ouvert',
      way_1: 'Normalement Fermé',
    },
    LogEvent: {
      LOG_0: 'Veuillez patienter...',
      LOG_10: 'Démarrage de la Smart TX. Version du logiciel M1 :',
      LOG_100: 'Impossible d\'effectuer la redirection UPNP sans adresse IP',
      LOG_1000: 'La Smart TX fonctionne en mode fail-over sur',
      LOG_1001: 'La Smart TX fonctionne en mode passerelle VOIP',
      LOG_1002: 'La Smart TX fonctionne en mode passerelle GSM',
      LOG_1003: 'La Smart TX fonctionne en mode inconnu',
      LOG_1004: 'La Smart TX fonctionne en mode fail-over sur VOIP car le modem GSM est absent',
      LOG_1005: 'Nombre d\'heure avant le redémarrage du modem GSM :',
      LOG_1006: 'Pas de n° défini pour les notifications SMS',
      LOG_1008: 'Test cyclique des notifications',
      LOG_101: 'Redirection UPNP réalisée avec succès',
      LOG_1014: 'Appel terminé',
      LOG_1015: 'Appel entrant terminé',
      LOG_1016: 'Modem GSM présent',
      LOG_1019: 'Appel entrant',
      LOG_102: 'Impossible d\'effectuer la redirection UPNP :',
      LOG_1025: 'Début d\'alarme sur l\'entrée',
      LOG_1026: 'Fin de l\'alarme sur l\'entrée',
      LOG_1027: 'Activation de la sortie ',
      LOG_1028: 'Désactivation de la sortie ',
      LOG_1029: 'Début de l\'impulsion sur la sortie ',
      LOG_1030: 'Fin de l\'impulsion sur la sortie ',
      LOG_1050: 'Perte du réseau LAN',
      LOG_1051: 'Perte du réseau GSM',
      LOG_1060: 'Récupération du réseau LAN',
      LOG_1061: 'Récupération du réseau GSM',
      LOG_1070: 'Réseau LAN disponible',
      LOG_1071: 'Connexion GSM établie',
      LOG_1080: 'Mise à l\'heure détectée, rechargement du test cyclique ',
      LOG_1083: 'Un nouveau message vient d\'être reçu',
      LOG_1084: 'Code SMS fourni erroné',
      LOG_1085: 'Demande de changement d\'état de la sortie reçue',
      LOG_1086: 'Demande de fonction non reconnue',
      LOG_1087: 'Impossible de supprimer le SMS reçu',
      LOG_1088: 'Appel impossible sans N° de destinataire',
      LOG_1089: 'Appel terminé pour cause de durée maximum atteinte',
      LOG_1090: 'Marche sur l\'entrée',
      LOG_1091: 'Arrêt sur l\'entrée',
      LOG_1092: 'Chute de la tension',
      LOG_1093: 'Mode configuré pour ce numéro : ',
      LOG_1098: 'Extinction d\'urgence',
      LOG_1099: 'Retour de l\'alimentation',
      LOG_11: 'Cable réseau branché',
      LOG_1100: 'Trame reçue sans STX',
      LOG_1101: 'Ligne analogique présente',
      LOG_1102: 'Ligne analogique absente',
      LOG_1103: 'Prise de la ligne par l\'équipement',
      LOG_1104: 'Restitution de la ligne par l\'équipement',
      LOG_1105: 'Numéro de l\'appelant',
      LOG_1106: 'Version du logiciel M2 :',
      LOG_1107: 'Retour usine demandé',
      LOG_1108: 'Tension de l\'alimentation trop faible',
      LOG_1109: 'Action inconnue demandée',
      LOG_1110: 'Trame inatendue reçue',
      LOG_1111: 'Redémarrage suite coupure alimentation',
      LOG_1112: 'Redémarrage suite reset software M1',
      LOG_1113: 'Redémarrage suite reset software M2',
      LOG_1114: 'Redémarrage suite à une cause inconnue',
      LOG_1115: 'Redémarrage suite hard reset software M2',
      LOG_1200: 'Pas d\'adresse IP',
      LOG_1201: 'Adresse IP détectée',
      LOG_1202: 'Impossible d\'obtenir une adresse IP',
      LOG_1203: 'Cable réseau branché',
      LOG_1204: 'Cable réseau débranché',
      LOG_13: 'Carte son non détecté',
      LOG_1300: 'Trame reçue',
      LOG_1301: 'Trame invalide reçue',
      LOG_1302: 'Impossible d\'ouvrir la liaison série',
      LOG_1303: 'Envoi de la trame',
      LOG_14: 'Erreur grave dans la création du thread',
      LOG_1400: 'Email envoyé avec succès vers',
      LOG_1401: 'Erreur dans l\'envoi de mail',
      LOG_15: 'Erreur grave dans l\'association du thread',
      LOG_1500: 'Fichier de langue introuvable',
      LOG_1501: 'Erreur dans le lecture du fichier de langue',
      LOG_1900: 'Impossible d\'ouvrir la liaison série avec le GSM',
      LOG_1901: 'Modem configuré',
      LOG_1902: 'Modem non configuré',
      LOG_1903: 'Non enregistré sur le réseau GSM, ne recherche pas actuellement un autre opérateur',
      LOG_1904: 'Enregistré sur le réseau GSM',
      LOG_1905: 'Non enregistré sur le réseau GSM, recherche d\'un opérateur en cours',
      LOG_1906: 'Enregistré sur le réseau GSM refusé',
      LOG_1907: 'Etat de l\'enregistrement sur le réseau GSM inconnu',
      LOG_1908: 'Enregistré sur le réseau GSM (en roaming)',
      LOG_1909: 'Etat de l\'enregistrement sur le réseau GSM inconnu',
      LOG_1910: 'Impossible d\'obtenir l\'état de l\'enregistrement sur le réseau GSM',
      LOG_1911: 'Rejet de l\'appel GSM entrant',
      LOG_1912: 'Carte SIM présente',
      LOG_1913: 'Défaut avec la carte SIM',
      LOG_1914: 'Code PIN OK',
      LOG_1915: 'Code PIN erroné',
      LOG_1916: 'Code PIN désactivé avec succès',
      LOG_1917: 'Impossible de désactiver le code PIN',
      LOG_1918: 'Impossible d\'effectuer l\'appel sans être enregistré sur le réseau',
      LOG_1919: 'Impossible d\'envoyer le SMS sans être enregistré sur le réseau',
      LOG_1920: 'SMS envoyé avec succès à ',
      LOG_1921: 'Une erreur est survenue lors de l\'envoi du SMS',
      LOG_1922: 'Liste des opérateurs récupérée avec succès',
      LOG_1923: 'Une erreur est survenue lors de la recherche des opérateurs',
      LOG_1924: 'Une erreur est survenue lors de la récupération de l\'état de la carte SIM',
      LOG_1925: 'Rejet de l\'appel entrant GSM car l\'équipement tient la ligne',
      LOG_1926: 'Modem GSM non prêt pour traiter la commande',
      LOG_1927: 'Une erreur est survenue lors de la lecture du SMS reçu',
      LOG_1928: 'Modem GSM non connecté au réseau de données',
      LOG_1929: 'Envoi de la commande',
      LOG_1930: 'Lien GSM non établi ou déconnecté (ex : raccroché du distant)',
      LOG_1931: 'Destinataire GSM occupé',
      LOG_1932: 'Sélection manuelle de l\'opérateur :',
      LOG_1933: 'Début de l\'initialisation du modem GSM',
      LOG_1934: 'Fin de l\'initialisation du modem GSM',
      LOG_200: 'Fichier de configuration absent',
      LOG_2000: 'Web : modification de la configuration réseau',
      LOG_2001: 'Web : modification de la configuration UPNP',
      LOG_2002: 'Web : modification de la configuration de la liste blanche',
      LOG_2004: 'Web : modification de la configuration des accès',
      LOG_2005: 'Web : modification de la configuration des destinataires',
      LOG_2006: 'Web : modification de la configuration des notifications',
      LOG_2007: 'Web : modification de la configuration des entrées',
      LOG_2008: 'Web : modification de la configuration des sorties',
      LOG_2009: 'Web : modification de la configuration des test cyclique',
      LOG_201: 'Erreur dans la lecture de la configuration :',
      LOG_2010: 'Web : modification de la configuration du modem GSM',
      LOG_2011: 'Web : envoi d\'une commande au Modem GSM',
      LOG_2012: 'Web : envoi d\'une commande au MC',
      LOG_2013: 'Web : demande de suppression du code PIN',
      LOG_2014: 'Web : modification de la configuration de la langue',
      LOG_2015: 'Web : modification de la configuration du SMTP',
      LOG_2016: 'Web : modification de la configuration du mode de fonctionnement',
      LOG_2018: 'Web : changement de l\'état d\'une sortie',
      LOG_2019: 'Web : connexion utilisateur réussie',
      LOG_202: 'Echec de chargement de la configuration à restaurer :',
      LOG_2020: 'Web : connexion administrateur réussie',
      LOG_2021: 'Web : connexion échouée',
      LOG_2022: 'Web : redémarrage demandé',
      LOG_2023: 'Web : mise à jour du logiciel demandée',
      LOG_2024: 'Web : restauration des paramètres usine demandée',
      LOG_2025: 'Web : demande de rédémarrage du modem GSM',
      LOG_2026: 'Web : restauration de la configuration demandée',
      LOG_2027: 'Web : fichier de configuration non valide',
      LOG_2028: 'Web : configuration restaurée',
      LOG_2029: 'Web : test des destinataires',
      LOG_2030: 'Web : modification de la configuration du code secret SMS',
      LOG_2031: 'Web : nouveau firmware téléchargé avec succès, il va être appliqué',
      LOG_2032: 'Web : le firmware n\'est pas intègre et ne sera pas appliqué',
      LOG_2034: 'Web : modification de la configuration de l\'audio',
      LOG_2036: 'Web : modification de la configuration de l\'application écoute',
      LOG_2037: 'Web : modification du protocole pour le webserver',
      LOG_2038: 'Web : modification de la configuration de l\'application transmission',
      LOG_2039: 'Web : modification de la configuration GPRS',
      LOG_2040: 'Data : ',
      LOG_2041: 'Web : le firmware n\'est pas un firmware valide',
      LOG_2042: 'Web : le firmware a été téléchargé avec succès et va être appliqué ',
      LOG_2043: 'Web : Test du destinataire : ',
      LOG_2045: 'Web : rafraîchissement de l\'adresse IP publique',
      LOG_2047: 'Web : modification de la configuration des sondes',
      LOG_2048: 'Web : sélection manuelle de l\'opérateur',
      LOG_2049: 'Web : modification du mode du thermostat',
      LOG_2050: 'Web : modification du planning du thermostat',
      LOG_2300: 'Nouveau numéro ajouté en mode transparent : ',
      LOG_2301: 'Le réseau suivant sera désormais utilisé  : ',
      LOG_2302: 'Aucun réseau disponible pour transmettre',
      LOG_2303: 'Retour sur le réseau configuré comme réseau principal',
      LOG_2304: 'Connectivité du réseau GSM',
      LOG_2305: 'Impossible changer l\'état d\'une sortie qui n\'est pas en télécommande',
      LOG_2306: 'Impossible d\'établir la communication avec',
      LOG_2307: 'Impossible d\'établir la communication car',
      LOG_2308: 'Alarme sur température trop élévée ',
      LOG_2309: 'Alarme sur température trop basse ',
      LOG_2310: 'Fin d\'alarme sur dépassement de seuil de température',
      LOG_2311: 'Mise à l\'heure via ',
      LOG_2312: 'Dépassement de la valeur quotidienne du compteur',
      LOG_2313: 'Thermostat : activation de la sortie ',
      LOG_2314: 'Thermostat : désactivation de la sortie ',
      LOG_2315: 'Défaut sur la sonde de température ',
      LOG_2316: 'Fin de défaut sur la sonde de température ',
      LOG_2317: 'Thermostat : changement de mode suivant le planning :',
      LOG_2318: 'Thermostat : changement de mode depuis le clavier :',
      LOG_2400: 'Connecté au cloud',
      LOG_2401: 'Erreur lors de la tentative de connexion au cloud',
      LOG_2402: 'Déconnecté au cloud',
      LOG_2403: 'Application : demande de mise à jour des firmwares',
      LOG_2404: 'Application : demande de synchronisation',
      LOG_2405: 'Application : changement d\'état de la sortie',
      LOG_2406: 'Application : modification de la configuration de la sonde',
      LOG_2407: 'Application : modification de la configuration de la sortie ',
      LOG_2408: 'Application : modification de la configuration de l\'entrée',
      LOG_2409: 'Application : test de destinataire',
      LOG_2410: 'Application : enresgitrement des destinataires',
      LOG_2411: 'Application : enresgitrement des planning de thermostat',
      LOG_2412: 'Application : data : ',
      LOG_300: 'Média non géré pour la notification',
      LOG_301: 'Les conditions ne sont pas encore requises pour l\'envoi du message de type',
      LOG_400: 'Temps d\'inactivité du MC dépassé',
      title: 'Historique',
    },
    Login: {
      email: 'Email',
      login: 'Se connecter',
      lostPassword: 'Mot de passe perdu ?',
      notYetMemeber: 'Pas encore membre',
      password: 'Mot de passe',
      register: 'Enregistrement',
      rememberMe: 'Se souvenir de moi',
    },
    LostPassword: {
      email: 'Adresse mail',
      send: 'ME RENVOYER UN MOT DE PASSE',
      title: 'Mot de passe perdu',
    },
    Media: {
      alarm: 'Alarmes',
      mail: 'Email',
      notification: 'Evts internes',
      push: 'Notif. PUSH',
      sms: 'SMS',
    },
    Menu: {
      alarm: 'Alarmes',
      habilitedUsers: 'Utilisateurs habilités',
      help: 'Aide',
      logEvent: 'Historique',
      password: 'Mot de passe',
      push: 'Recevoir les pushs',
      recipient: 'Liste des destinataires',
      signout: 'Déconnexion',
      site: 'Liste des sites',
      sms: 'Pilotage par SMS',
      status: 'Informations systèmes',
    },
    Output: {
      label: 'Nom',
      mode_0: 'On / Off',
      mode_1: 'Impulsionnel',
      temporisationUnit: 'Unité',
      temporisationValue: 'Temporisation',
      temporisationValueShort: 'TEMPORISATION',
    },
    RecipientList: {
      confirmNotChecked: 'Vous n\'avez rien cocher pour ce destinataire, il sera supprimé. Etes-vous sûr de vouloir de continuer ?',
      maxTenInputAlarm: 'Vous ne pouvez pas avoir plus de 10 destinataires pour les alarmes',
      maxTenTechnicalAlarm: 'Vous ne pouvez pas avoir plus de 10 destinataires pour les notifications',
      test: 'Envoyer des messages de test',
      title: 'Destinataires',
      titleEdit: 'Modif. du destinataire',
    },
    Register: {
      confirmation: 'Confirmation du mot de passe',
      errors: {
        confirmation: 'La confirmation doit être identique au mot de passe',
      },
      register: 'INSCRIPTION',
      title: "Inscription",
    },
    Schedule: {
      dateTimeCancel: 'Annuler',
      dateTimeCancelButtonLabel: 'Annuler',
      dateTimeDoneButtonLabel: 'Ok',
      dateTimeOk: 'Valider',
      dateTimeTitle: 'Choisir une heure',
      errorDayMandatory: 'Veuillez choisir à minima un jour par plage horaire',
      errorStartAfterEnd: 'L\'heure de fin doit être postérieure à l\'heure de début',
      maxSchedule: 'Vous ne pouvez pas créer plus de 35 plages',
      title: 'Planning',
    },
    SiteAdd: {
      code: 'Code',
      errorCode: 'Le format du code est incorrect',
      errorName: 'Le format du nom est incorrect',
      name: 'Nom',
      title: 'Ajouter un site',
    },
    SiteEdit: {
      errorName: 'Le format du nom est incorrect',
      name: 'Nom',
      title: 'Modification du nom',
    },
    Sms: {
      apnConnect: 'Appliquer les paramètres APN',
      apnGet: 'Paramètres APN',
      apnPassword: 'Mot de passe APN',
      apnServer: 'APN',
      apnUser: 'Utilisateur APN',
      changePassword: 'Modifier le code secret',
      groupAction: 'Télécommandes',
      groupApn: 'APN & Code',
      groupQuery: 'Interrogations',
      groupThermostat: 'Thermostat',
      in1: 'Etat de l\'entrée 1',
      in2: 'Etat de l\'entrée 2',
      info: 'Informations systèmes',
      out1off: 'Arrêt Out 1',
      out1on: 'Marche Out 1',
      out2off: 'Arrêt Out 2',
      out2on: 'Marche Out 2',
      phoneNumber: 'N° SIM de la Smart TX',
      temp1: 'Température Sonde 1',
      temp2: 'Température Sonde 2',
      thermostatDisable: 'Désactiver le thermostat',
      thermostatMode: 'Mode courant du thermostat',
      title: 'Pilotage par SMS'
    },
    Status: {
      alreadyUptodate: 'Votre Smart TX est déjà à jour',
      appVersion: 'Version de l\'app',
      battery: 'Batterie de secours',
      battery_good: 'Chargée',
      battery_medium: 'Charge en cours',
      battery_poor: 'Déchargée',
      battery_unknown: 'Absente ou Hors service',
      connectionType: 'Type de connexion',
      disconnected: 'Non Connecté',
      gsmNumber: 'Num Tél SIM',
      gsmOperator: 'Opérateur',
      ipAddress: 'Adresse IP',
      lastDate: 'Dernière remontée',
      m1Version: 'Version M1',
      m2Version: 'Version M2',
      mac: 'Adresse Mac',
      remoteIp: 'IP publique',
      sector: 'Alimentation',
      title: 'Informations systèmes',
      update: 'Mise à jour firmwares',
    },

    Temperature: {
      label: 'Nom de la sonde',
      thermostat: 'Thermostat sur sortie ',
      thresholdCalibration: 'Correction mesure (°C)',
      thresholdCalibrationShort: 'CORRECTION',
      thresholdDelta: 'Delta reset seuil (°C)',
      thresholdDeltaShort: 'DELTA RESET',
      thresholdDown: 'Seuil d\'alerte bas (°C)',
      thresholdDownShort: 'SEUIL BAS',
      thresholdNotCorrect: 'Le seuil haut doit être supérieur au seuil bas augmenté du delta reset',
      thresholdUp: 'Seuil d\'alerte haut (°C)',
      thresholdUpShort: 'SEUIL HAUT',
    },
    Thermostat: {
      modeComfort: 'Confort',
      modeEco: 'Eco',
      modeFrost: 'Hors-gel',
      modeOff: 'Utiliser le thermostat',
      modePlanning: 'Planning',
      planningNotAvailable: 'La planification n\'est pas disponible sans créneau horaire défini',
      setpointComfort: 'Confort (°C)',
      setpointComfortShort: 'Confort',
      setpointEco: 'Eco (°C)',
      setpointEcoShort: 'Eco',
      setpointFrost: 'Hors-gel  (°C)',
      setpointFrostShort: 'Hors-gel',
      setpointOrderError: 'Les consignes doivent être par ordre croissant : Hors-Gel , Eco , Confort',
      title: 'Thermostat',
    },
    User: {
      lastConnection: 'Dernière connexion le',
      title: 'Liste des utilisateurs',
    }
  }
};

let it: ITranslationProps;
it = {
  i18n: {
    Alarm: {
      COUNTERMAXEXCEEDED: 'Contatore oltre limite',
      INPUTALARMBEGIN: 'Allarme',
      INPUTALARMEND: 'Fine dell\'allarme',
      POWERSUPPLYBATTERYDOWN: 'Batteria scarica',
      POWERSUPPLYBATTERYUP: 'Batterie carica',
      POWERSUPPLYSECTORDOWN: 'Mancanza alimentazione',
      POWERSUPPLYSECTORUP: 'Ritorno alimentazione',
      SENSORDEFAULT: 'Anomalia alla sonda',
      SENSORDEFAULTEND: 'Fine anomalia',
      THRESHOLDDOWN: 'Superamento soglia bassa',
      THRESHOLDOK: 'Ritorno a valore normale',
      THRESHOLDUP: 'Superamento soglia alta',
      title: 'Allarme',
    },
    ChangePassword: {
      change: 'Modificare la password',
      newPassword: 'Nuova password',
      oldPassword: 'Vecchia password',
      title: 'Password',
    },
    Common: {
      alert: 'Avvisare per',
      confirmCancel: 'Siete sicuri di volere annullare le modifiche?',
      day_0: 'D',
      day_1: 'L',
      day_2: 'M',
      day_3: 'M',
      day_4: 'G',
      day_5: 'V',
      day_6: 'S',
      email: 'Email',
      errors: {
        401: 'Email o password errate',
        500: 'Il server ha riscontrato un errore, riprovare',
        DEVICE_CODE_NOT_FOUND: 'Codice non riconosciuto',
        DEVICE_NOT_FOUND: 'Attendi fino a quando Smart TX non è connesso al Cloud',
        ERROR: 'Si è verificato un errore',
        ERROR_UPDATING_PASSWORD: 'La vecchia password o la nuova non sono corrette',
        NETWORK: 'Errore di rete, verificate la connessione',
        // NETWORK: 'Si è verificato un errore, riprovare',
        OUTPUT_CHANGE_NOT_ALLOWED: 'Cambiamenti non autorizzati nella modalità termostato',
        TEST_TOO_EARLY: 'Attendere almeno 1 minuto tra i due test',
        TIMEOUT: 'La Smart TX ha impiegato troppo tempo a rispondere',
        UNKNOW_COMMAND: 'Il comando non può essere processato',
        USER_EXISTS: 'Indirizzo email già in uso',
        USER_NOT_EXISTS: 'Verificate l \'email',
        email: 'L\'indirizzo email non è corretto',
        invalidField: 'Campo non valido',
        password: 'Questo campo deve avere almeno 4 caratteri',
        phoneNumber: 'Il numero di telefono non è corretto',
        testSent: 'La richiesta di test è stata presa in carico',
      },
      mode: 'Modalità di funzionamento',
      no: 'No',
      password: 'Password',
      phone: 'Numero di telefono (SMS)',
      unit: 'Unità',
      units: {
        hour: 'Ore',
        kilowatt: 'KiloWatt',
        liter: 'Litri',
        meter: 'Metri cubi',
        minute: 'Minuti',
        second: 'Secondi',
        watt: 'Watt',
      },
      yes: 'Si'
    },

    DashBoard: {
      noSensor: 'Nessuna sonda collegata',
      offLine: ' Off line',
      waitForSync: 'Attendere prima di fare una nuova richiesta',
    },
    Home: {
      confirmDelete: 'Siete sicuri di volere cancellare questo sito?',
      home: 'Home',
      smartremote: 'Smart TX',
    },
    Input: {
      backToNormal: 'Gestione del ritorno alla normalità',
      counterMax: 'Valori massimi giornalieri',
      counterMaxShort: 'MAX GIORNALIERI',
      counterTotal: 'Totale',
      counterTotalShort: 'TOTALE',
      counterWeight: 'peso dell\'impulso',
      counterWeightShort: 'PESO',
      disparitionValue: 'Integrazione al ripristino',
      disparitionValueShort: 'INTEGRAZIONE',
      integrationValue: 'Integrazione all\'evento',
      integrationValueShort: 'INTEGRAZIONE',
      label: 'Nome',
      mode_0: 'Modalità di Allarme',
      mode_1: 'Modalità On / Off',
      mode_2: 'Contatore impulsivo',
      way: 'Senso di funzionamento',
      way_0: 'Normalmente Aperto',
      way_1: 'Normalmente Chiuso',
    },
    LogEvent: {
      LOG_0: "Per favore aspetta ...",
      LOG_10: "Avvio di Smart TX. Versione software M1:",
      LOG_100: "Impossibile eseguire il reindirizzamento UPNP senza indirizzo IP",
      LOG_1000: "Lo Smart TX funziona in modalità di failover",
      LOG_1001: "Lo Smart TX funziona in modalità gateway VOIP",
      LOG_1002: "Smart TX funziona in modalità gateway GSM",
      LOG_1003: "Smart TX funziona in modalità sconosciuta",
      LOG_1004: "Smart TX funziona in modalità failover su VOIP perché il modem GSM è assente",
      LOG_1005: "Numero di ore prima di riavviare il modem GSM:",
      LOG_1006: "Nessun numero impostato per le notifiche SMS",
      LOG_1008: "Test ciclico delle notifiche",
      LOG_101: "Reindirizzamento UPNP completato correttamente",
      LOG_1014: "Chiamata terminata",
      LOG_1015: "Chiamata in arrivo completata",
      LOG_1016: "Presente modem GSM",
      LOG_1019: "Chiamata in arrivo",
      LOG_102: "Impossibile eseguire il reindirizzamento UPNP:",
      LOG_1025: "Inizio dell'allarme all'ingresso",
      LOG_1026: "Fine dell'allarme all'ingresso",
      LOG_1027: "Attivazione dell'output",
      LOG_1028: "Disabilitare l'output",
      LOG_1029: "Inizio dell'impulso all'uscita",
      LOG_1030: "Fine dell'impulso all'uscita",
      LOG_1050: "Perdita LAN",
      LOG_1051: "Perdita della rete GSM",
      LOG_1060: "Ripristino della rete LAN",
      LOG_1061: "Recupero della rete GSM",
      LOG_1070: "LAN disponibile",
      LOG_1071: "Connessione GSM stabilita",
      LOG_1080: "Rilevata impostazione del tempo, ricarico del test ciclico",
      LOG_1083: "Un nuovo messaggio è stato appena ricevuto",
      LOG_1084: "Codice SMS errato fornito",
      LOG_1085: "Richiesta di modificare lo stato dell'output ricevuto",
      LOG_1086: "Richiesta di funzione non riconosciuta",
      LOG_1087: "Impossibile eliminare gli SMS ricevuti",
      LOG_1088: "Impossibile chiamare senza numero di destinatario",
      LOG_1089: "Chiamata completata a causa della massima durata raggiunta",
      LOG_1090: "On sull'ingresso",
      LOG_1091: "Fermati all'ingresso",
      LOG_1092: "Tensione in calo",
      LOG_1093: "Modalità configurata per questo numero:",
      LOG_1098: "Estinzione di emergenza",
      LOG_1099: "Ritorno dell'alimentazione elettrica",
      LOG_11: "Cavo di rete trendy",
      LOG_1100: "Ricevuto frame senza STX",
      LOG_1101: "Linea analogica presente",
      LOG_1102: "Linea analogica assente",
      LOG_1103: "Prendendo la linea dall'attrezzatura",
      LOG_1104: "Ritorno della linea dall'equipaggiamento",
      LOG_1105: "Il numero del chiamante",
      LOG_1106: "Versione software M2:",
      LOG_1107: "Richiesta di reso di fabbrica",
      LOG_1108: "Tensione di alimentazione troppo bassa",
      LOG_1109: "Azione sconosciuta richiesta",
      LOG_1110: "Frame imprevisto ricevuto",
      LOG_1111: "Riavvia dopo un'interruzione di corrente",
      LOG_1112: "Riavvia dopo aver ripristinato il software M1",
      LOG_1113: "Riavvia dopo aver ripristinato il software M2",
      LOG_1114: "Riavvio a causa di una causa sconosciuta",
      LOG_1115: "Riavviare il software di reimpostazione hardware suite M2",
      LOG_1200: "Nessun indirizzo IP",
      LOG_1201: "Rilevato l'indirizzo IP",
      LOG_1202: "Impossibile ottenere un indirizzo IP",
      LOG_1203: "Cavo di rete trendy",
      LOG_1204: "Cavo di rete scollegato",
      LOG_13: "Scheda audio non rilevata",
      LOG_1300: "Telaio ricevuto",
      LOG_1301: "Frame non valido ricevuto",
      LOG_1302: "Impossibile aprire il collegamento seriale",
      LOG_1303: "Invio della cornice",
      LOG_14: "Errore grave nella creazione del thread",
      LOG_1400: "Email inviata con successo a",
      LOG_1401: "Errore nell'invio della posta",
      LOG_15: "Errore grave nell'associazione thread",
      LOG_1500: "File di lingua non trovato",
      LOG_1501: "Errore durante la lettura del file di lingua",
      LOG_1900: "Impossibile aprire il collegamento seriale con GSM",
      LOG_1901: "Modem configurato",
      LOG_1902: "Modem non configurato",
      LOG_1903: "Non registrato sulla rete GSM, non è attualmente alla ricerca di un altro operatore",
      LOG_1904: "Registrato sulla rete GSM",
      LOG_1905: "Non registrato sulla rete GSM, cercare un operatore in corso",
      LOG_1906: "Registrato sulla rete GSM rifiutato",
      LOG_1907: "Stato di registrazione sulla rete GSM sconosciuta",
      LOG_1908: "Registrato sulla rete GSM (roaming)",
      LOG_1909: "Stato di registrazione sulla rete GSM sconosciuta",
      LOG_1910: "Impossibile ottenere lo stato di registrazione sulla rete GSM",
      LOG_1911: "Rifiuto della chiamata GSM in arrivo",
      LOG_1912: "Carta SIM presente",
      LOG_1913: "Predefinito con la carta SIM",
      LOG_1914: "Codice PIN OK",
      LOG_1915: "Codice PIN errato",
      LOG_1916: "Codice PIN disattivato con successo",
      LOG_1917: "Impossibile disabilitare il PIN",
      LOG_1918: "Impossibile effettuare la chiamata senza essere registrati sulla rete",
      LOG_1919: "Non è possibile inviare SMS senza essere registrati sulla rete",
      LOG_1920: "SMS inviato con successo a",
      LOG_1921: "Si è verificato un errore durante l'invio dell'SMS",
      LOG_1922: "Elenco di operatori ripristinati con successo",
      LOG_1923: "Si è verificato un errore durante la ricerca degli operatori",
      LOG_1924: "Si è verificato un errore durante il recupero dello stato della carta SIM",
      LOG_1925: "Rifiuto della chiamata GSM in arrivo mentre l'apparecchiatura mantiene la linea",
      LOG_1926: "Modem GSM non pronto per elaborare l'ordine",
      LOG_1927: "Si è verificato un errore durante la lettura degli SMS ricevuti",
      LOG_1928: "Modem GSM non connesso alla rete dati",
      LOG_1929: "L'invio dell'ordine",
      LOG_1930: "Collegamento GSM non stabilito o disconnesso (es: bloccato dal telecomando)",
      LOG_1931: "Destinatario GSM occupato",
      LOG_1932: "Selezione manuale dell'operatore:",
      LOG_1933: "Inizio dell'inizializzazione del modem GSM",
      LOG_1934: "Fine dell'inizializzazione del modem GSM",
      LOG_200: "File di configurazione non presente",
      LOG_2000: "Web: modifica della configurazione di rete",
      LOG_2001: "Web: modifica della configurazione UPNP",
      LOG_2002: "Web: modifica della configurazione della lista bianca",
      LOG_2004: "Web: modifica della configurazione di accesso",
      LOG_2005: "Web: modifica della configurazione del destinatario",
      LOG_2006: "Web: modifica della configurazione della notifica",
      LOG_2007: "Web: modifica della configurazione di input",
      LOG_2008: "Web: modifica della configurazione di output",
      LOG_2009: "Web: modifica della configurazione del test ciclico",
      LOG_201: "Errore nella lettura della configurazione:",
      LOG_2010: "Web: modifica della configurazione del modem GSM",
      LOG_2011: "Web: invio di un ordine al modem GSM",
      LOG_2012: "Web: invio di un ordine al MC",
      LOG_2013: "Web: richiesta di cancellazione del PIN",
      LOG_2014: "Web: modifica della configurazione della lingua",
      LOG_2015: "Web: modifica della configurazione SMTP",
      LOG_2016: "Web: modifica della configurazione della modalità operativa",
      LOG_2018: "Web: modifica dello stato di un output",
      LOG_2019: "Web: login utente riuscito",
      LOG_202: "Impossibile caricare la configurazione per ripristinare:",
      LOG_2020: "Web: login amministratore riuscito",
      LOG_2021: "Web: connessione fallita",
      LOG_2022: "Web: riavvio richiesto",
      LOG_2023: "Web: richiesto l'aggiornamento del software",
      LOG_2024: "Web: Ripristina impostazioni di fabbrica richieste",
      LOG_2025: "Web: richiesta di riavvio del modem GSM",
      LOG_2026: "Web: ripristino della configurazione richiesta",
      LOG_2027: "Web: file di configurazione non valido",
      LOG_2028: "Web: configurazione ripristinata",
      LOG_2029: "Web: test del destinatario",
      LOG_2030: "Web: modifica della configurazione del codice segreto SMS",
      LOG_2031: "Web: nuovo firmware scaricato correttamente, verrà applicato",
      LOG_2032: "Web: il firmware non è onesto e non verrà applicato",
      LOG_2034: "Web: modifica della configurazione audio",
      LOG_2036: "Web: modifica della configurazione dell'applicazione di ascolto",
      LOG_2037: "Web: modifica del protocollo per il webserver",
      LOG_2038: "Web: modifica della configurazione dell'applicazione di trasmissione",
      LOG_2039: "Web: modifica della configurazione GPRS",
      LOG_2040: "Dati:",
      LOG_2041: "Web: il firmware non è un firmware valido",
      LOG_2042: "Web: il firmware è stato scaricato correttamente e verrà applicato",
      LOG_2043: "Web: Test del destinatario:",
      LOG_2045: "Web: aggiornamento dell'indirizzo IP pubblico",
      LOG_2047: "Web: modifica della configurazione delle sonde",
      LOG_2048: "Web: selezione manuale dell'operatore",
      LOG_2049: "Web: modifica della modalità del termostato",
      LOG_2050: "Web: modifica del programma del termostato",
      LOG_2300: "Nuovo numero aggiunto in modalità trasparente:",
      LOG_2301: "Verrà ora utilizzata la seguente rete:",
      LOG_2302: "Nessuna rete disponibile per la trasmissione",
      LOG_2303: "Torna sulla rete configurata come backbone",
      LOG_2304: "Connettività di rete GSM",
      LOG_2305: "Non è possibile modificare lo stato di un'uscita che non è in un controllo remoto",
      LOG_2306: "Impossibile stabilire una comunicazione con",
      LOG_2307: "Impossibile stabilire la comunicazione perché",
      LOG_2308: "Allarme di temperatura troppo alto",
      LOG_2309: "Allarme su temperatura troppo bassa",
      LOG_2310: "Fine dell'allarme al superamento della soglia di temperatura",
      LOG_2311: "Impostazione del tempo tramite",
      LOG_2312: "Superamento del valore giornaliero del contatore",
      LOG_2313: "Termostato: attivazione dell'uscita",
      LOG_2314: "Termostato: disattivazione dell'uscita",
      LOG_2315: "Guasto sul sensore di temperatura",
      LOG_2316: "Fine del guasto sulla sonda di temperatura",
      LOG_2317: "Termostato: cambio di modalità in base al programma:",
      LOG_2318: "Termostato: cambio di modalità dalla tastiera:",
      LOG_2400: "Connesso al cloud",
      LOG_2401: "Errore durante il tentativo di connessione al cloud",
      LOG_2402: "Disconnesso dal cloud",
      LOG_2403: "Applicazione: aggiorna l'applicazione per il firmware",
      LOG_2404: "Applicazione: richiesta di sincronizzazione",
      LOG_2405: "Applicazione: cambio di stato dell'output",
      LOG_2406: "Applicazione: modifica della configurazione della sonda",
      LOG_2407: "Applicazione: modifica della configurazione di output",
      LOG_2408: "Applicazione: modifica della configurazione dell'ingresso",
      LOG_2409: "Applicazione: test del destinatario",
      LOG_2410: "Applicazione: registrazione dei destinatari",
      LOG_2411: "Applicazione: pianificazione della rigenerazione",
      LOG_2412: "Applicazione: dati:",
      LOG_300: "Media non gestito per la notifica",
      LOG_301: "Le condizioni non sono ancora richieste per l'invio del messaggio tipo",
      LOG_400: "Tempo di inattività MC superato",
      title: 'Storico eventi',
    },
    Login: {
      email: 'Email',
      login: 'Collegarsi',
      lostPassword: 'Password dimenticata?',
      notYetMemeber: 'Non ancora registrato',
      password: 'Password',
      register: 'Registrazione',
      rememberMe: 'Ricorarsi di me',
    },
    LostPassword: {
      email: 'Indirizzo email',
      send: 'RIMANDAMI UNA PASSWORD',
      title: 'Password dimenticata',
    },
    Media: {
      alarm: 'Allarme',
      mail: 'Email',
      notification: 'Eventi di sistema',
      push: 'Notif. PUSH',
      sms: 'SMS',
    },
    Menu: {
      alarm: 'Allarme',
      habilitedUsers: 'Utenti abilitati',
      help: 'Aiuto',
      logEvent: 'Storico eventi',
      password: 'Password',
      push: 'Ricevere i pushs',
      recipient: 'Elenco destinatari',
      signout: 'Disconnessione',
      site: 'Elenco dei siti',
      sms: 'Controllo SMS',
      status: 'Informazioni di sistema',
    },
    Output: {
      label: 'Nome',
      mode_0: 'On / Off',
      mode_1: 'Impulsivo',
      temporisationUnit: 'Unità',
      temporisationValue: 'Temporizzazione',
      temporisationValueShort: 'TEMPORIZZAZIONE',
    },
    RecipientList: {
      confirmNotChecked: 'Non avete slezionato nulla per questo destinatario, sarà quindi cancellato. Siete sicuri di volere continuare?',
      maxTenInputAlarm: 'Il numero massimo di destinatari per gli allarmi è 10',
      maxTenTechnicalAlarm: 'Il numero massimo di destinatari per le notifiche è 10',
      test: 'Invia messagi di test',
      title: 'Destinatari',
      titleEdit: 'Modif. dei destinatari',
    },
    Register: {
      confirmation: 'Conferma password',
      errors: {
        confirmation: 'La conferma deve essere identica alla password',
      },
      register: 'RTEGISTRATI',
      title: "Registrati",
    },
    Schedule: {
      dateTimeCancel: 'Annulla',
      dateTimeCancelButtonLabel: 'Annulla',
      dateTimeDoneButtonLabel: 'Ok',
      dateTimeOk: 'Conferma',
      dateTimeTitle: 'Scegliere un orario',
      errorDayMandatory: 'Il giorno è obbligatorio per ogni programma',
      errorStartAfterEnd: 'L\'ora di fine deve essere successiva all\'ora di inizio',
      maxSchedule: 'Il numero massimo di programmi possibili è 35',
      title: 'Pianificazione',
    },
    SiteAdd: {
      code: 'Codice',
      errorCode: 'Formato del codice non corretto',
      errorName: 'Formato del nome non corretto',
      name: 'Nome',
      title: 'Aggiungere un sito',
    },
    SiteEdit: {
      errorName: 'Formato del nome non corretto',
      name: 'Nome',
      title: 'Modifica del nome',
    },
    Sms: {
      apnConnect: 'Applica impostazioni APN',
      apnGet: 'Ottieni parametri APN',
      apnPassword: 'Imposta la password APN',
      apnServer: 'Imposta APN',
      apnUser: 'Imposta utente APN',
      changePassword: 'Modifica il codice segreto',
      groupAction: 'Telecomandi',
      groupApn: 'APN & Code',
      groupQuery: 'Interrogatori',
      groupThermostat: 'Termostato',
      in1: 'Stato di entrata 1',
      in2: 'Stato di entrata 2',
      info: 'Informazioni di sistema',
      out1off: 'Out 1 Off',
      out1on: 'Out 1 On',
      out2off: 'Out 2 Off',
      out2on: 'Out 2 On',
      phoneNumber: 'Numero SIM di Smart TX',
      temp1: 'Sonda di temperatura 1',
      temp2: 'Sonda di temperatura 2',
      thermostatDisable: 'Disabilita il termostato',
      thermostatMode: 'Modalità del termostato corrente',
      title: 'Controllo SMS'
    },
    Status: {
      alreadyUptodate: 'Il vostro SMART TX è già aggiornato',
      appVersion: 'versione dell\'app',
      battery: 'Batteria in backup',
      battery_good: 'Carica sufficiente',
      battery_medium: 'Carica media',
      battery_poor: 'Carica scarsa',
      battery_unknown: 'Non connesso',
      connectionType: 'Tipo di connessione',
      disconnected: 'Non Connesso',
      gsmNumber: 'Num. Telefono SIM',
      gsmOperator: 'Operatore',
      ipAddress: 'Indirizzo IP',
      lastDate: 'Ultimo dato',
      m1Version: 'Versione M1',
      m2Version: 'Versione M2',
      mac: 'Indirizzo Mac',
      remoteIp: 'IP pubblico',
      sector: 'Alimentazione',
      title: 'Informazioni di sistema',
      update: 'Aggiornamento firmware',
    },

    Temperature: {
      label: 'Nome della sonda',
      thermostat: 'Termostato su uscita',
      thresholdCalibration: 'Correzione misura (°C)',
      thresholdCalibrationShort: 'CORREZIONE',
      thresholdDelta: 'Soglia di delta reset (°C)',
      thresholdDeltaShort: 'DELTA RESET',
      thresholdDown: 'Soglia di allarme bassa (°C)',
      thresholdDownShort: 'SOGLIA BASSA',
      thresholdNotCorrect: 'La soglia deve esseree superiore alla soglia bassa aumentata del delta reset',
      thresholdUp: 'Soglia di allarme alta(°C)',
      thresholdUpShort: 'SOGLIA ALTA',
    },
    Thermostat: {
      modeComfort: 'Confort',
      modeEco: 'Eco',
      modeFrost: 'Antigelo',
      modeOff: 'Usa il termostato',
      modePlanning: 'Programmazione',
      planningNotAvailable: 'La pianificazione non è disponibile senza intervallo di tempo definito',
      setpointComfort: 'Confort (°C)',
      setpointComfortShort: 'Confort',
      setpointEco: 'Eco (°C)',
      setpointEcoShort: 'Eco',
      setpointFrost: 'Antigelo  (°C)',
      setpointFrostShort: 'Antigelo',
      setpointOrderError: 'Le impostazioni devono essere in ordine crescente : Antigelo , Eco , Confort',
      title: 'Termostato',
    },
    User: {
      lastConnection: 'Ultimo collegamento il ',
      title: 'Elenco utenti',
    }
  }
};


export interface ITranslationProps {
  i18n: {
    Alarm: {
      title: string;
      INPUTALARMBEGIN: string;
      INPUTALARMEND: string;
      SENSORDEFAULT: string;
      SENSORDEFAULTEND: string;
      THRESHOLDDOWN: string;
      THRESHOLDUP: string;
      THRESHOLDOK: string;
      COUNTERMAXEXCEEDED: string;
      POWERSUPPLYSECTORDOWN: string;
      POWERSUPPLYBATTERYDOWN: string;
      POWERSUPPLYSECTORUP: string;
      POWERSUPPLYBATTERYUP: string;
    }
    Common: {
      day_0: string;
      day_1: string;
      day_2: string;
      day_3: string;
      day_4: string;
      day_5: string;
      day_6: string;
      confirmCancel: string;
      alert: string;
      email: string;
      errors: {
        email: string;
        password: string;
        phoneNumber: string;
        invalidField: string;
        testSent: string;
        401: string;
        500: string;
        ERROR: string
        NETWORK: string
        OUTPUT_CHANGE_NOT_ALLOWED: string;
        UNKNOW_COMMAND: string;
        USER_EXISTS: string;
        USER_NOT_EXISTS: string;
        DEVICE_CODE_NOT_FOUND: string;
        DEVICE_NOT_FOUND: string;
        ERROR_UPDATING_PASSWORD: string;
        TEST_TOO_EARLY: string;
        TIMEOUT: string;
      },
      mode: string;
      no: string;
      password: string;
      phone: string;
      unit: string;
      units: {
        hour: string;
        kilowatt: string;
        liter: string;
        meter: string;
        minute: string;
        second: string;
        watt: string;
      },
      yes: string;
    },
    ChangePassword: {
      change: string;
      oldPassword: string;
      newPassword: string;
      title: string;
    }
    DashBoard: {
      waitForSync: string;
      noSensor: string;
      offLine: string;
    },
    Home: {
      confirmDelete: string;
      home: string;
      smartremote: string;
    },
    Input: {
      backToNormal: string;
      counterTotal: string;
      counterTotalShort: string;
      counterWeight: string;
      counterWeightShort: string;
      counterMax: string;
      counterMaxShort: string;
      integrationValue: string;
      integrationValueShort: string;
      disparitionValue: string;
      disparitionValueShort: string;
      label: string;
      mode_0: string;
      mode_1: string;
      mode_2: string;
      way: string;
      way_0: string;
      way_1: string;
    },
    LogEvent: {
      LOG_0: string;
      LOG_10: string;
      LOG_11: string;
      LOG_13: string;
      LOG_14: string;
      LOG_15: string;
      LOG_100: string;
      LOG_101: string;
      LOG_102: string;
      LOG_200: string;
      LOG_201: string;
      LOG_202: string;
      LOG_300: string;
      LOG_301: string;
      LOG_400: string;
      LOG_1000: string;
      LOG_1001: string;
      LOG_1002: string;
      LOG_1003: string;
      LOG_1004: string;
      LOG_1005: string;
      LOG_1006: string;
      LOG_1008: string;
      LOG_1014: string;
      LOG_1015: string;
      LOG_1016: string;
      LOG_1019: string;
      LOG_1025: string;
      LOG_1026: string;
      LOG_1027: string;
      LOG_1028: string;
      LOG_1029: string;
      LOG_1030: string;
      LOG_1050: string;
      LOG_1051: string;
      LOG_1060: string;
      LOG_1061: string;
      LOG_1070: string;
      LOG_1071: string;
      LOG_1080: string;
      LOG_1083: string;
      LOG_1084: string;
      LOG_1085: string;
      LOG_1086: string;
      LOG_1087: string;
      LOG_1088: string;
      LOG_1089: string;
      LOG_1090: string;
      LOG_1091: string;
      LOG_1092: string;
      LOG_1093: string;
      LOG_1098: string;
      LOG_1099: string;
      LOG_1100: string;
      LOG_1101: string;
      LOG_1102: string;
      LOG_1103: string;
      LOG_1104: string;
      LOG_1105: string;
      LOG_1106: string;
      LOG_1107: string;
      LOG_1108: string;
      LOG_1109: string;
      LOG_1110: string;
      LOG_1111: string;
      LOG_1112: string;
      LOG_1113: string;
      LOG_1114: string;
      LOG_1115: string;
      LOG_1200: string;
      LOG_1201: string;
      LOG_1202: string;
      LOG_1203: string;
      LOG_1204: string;
      LOG_1300: string;
      LOG_1301: string;
      LOG_1302: string;
      LOG_1303: string;
      LOG_1400: string;
      LOG_1401: string;
      LOG_1500: string;
      LOG_1501: string;
      LOG_1900: string;
      LOG_1901: string;
      LOG_1902: string;
      LOG_1903: string;
      LOG_1904: string;
      LOG_1905: string;
      LOG_1906: string;
      LOG_1907: string;
      LOG_1908: string;
      LOG_1909: string;
      LOG_1910: string;
      LOG_1911: string;
      LOG_1912: string;
      LOG_1913: string;
      LOG_1914: string;
      LOG_1915: string;
      LOG_1916: string;
      LOG_1917: string;
      LOG_1918: string;
      LOG_1919: string;
      LOG_1920: string;
      LOG_1921: string;
      LOG_1922: string;
      LOG_1923: string;
      LOG_1924: string;
      LOG_1925: string;
      LOG_1926: string;
      LOG_1927: string;
      LOG_1928: string;
      LOG_1929: string;
      LOG_1930: string;
      LOG_1931: string;
      LOG_1932: string;
      LOG_1933: string;
      LOG_1934: string;
      LOG_2000: string;
      LOG_2001: string;
      LOG_2002: string;
      LOG_2004: string;
      LOG_2005: string;
      LOG_2006: string;
      LOG_2007: string;
      LOG_2008: string;
      LOG_2009: string;
      LOG_2010: string;
      LOG_2011: string;
      LOG_2012: string;
      LOG_2013: string;
      LOG_2014: string;
      LOG_2015: string;
      LOG_2016: string;
      LOG_2018: string;
      LOG_2019: string;
      LOG_2020: string;
      LOG_2021: string;
      LOG_2022: string;
      LOG_2023: string;
      LOG_2024: string;
      LOG_2025: string;
      LOG_2026: string;
      LOG_2027: string;
      LOG_2028: string;
      LOG_2029: string;
      LOG_2030: string;
      LOG_2031: string;
      LOG_2032: string;
      LOG_2034: string;
      LOG_2036: string;
      LOG_2037: string;
      LOG_2038: string;
      LOG_2039: string;
      LOG_2040: string;
      LOG_2041: string;
      LOG_2042: string;
      LOG_2043: string;
      LOG_2045: string;
      LOG_2047: string;
      LOG_2048: string;
      LOG_2049: string;
      LOG_2050: string;
      LOG_2300: string;
      LOG_2301: string;
      LOG_2302: string;
      LOG_2303: string;
      LOG_2304: string;
      LOG_2305: string;
      LOG_2306: string;
      LOG_2307: string;
      LOG_2308: string;
      LOG_2309: string;
      LOG_2310: string;
      LOG_2311: string;
      LOG_2312: string;
      LOG_2313: string;
      LOG_2314: string;
      LOG_2315: string;
      LOG_2316: string;
      LOG_2317: string;
      LOG_2318: string;
      LOG_2400: string;
      LOG_2401: string;
      LOG_2402: string;
      LOG_2403: string;
      LOG_2404: string;
      LOG_2405: string;
      LOG_2406: string;
      LOG_2407: string;
      LOG_2408: string;
      LOG_2409: string;
      LOG_2410: string;
      LOG_2411: string;
      LOG_2412: string;
      title: string;
    },
    Login: {
      email: string;
      login: string;
      notYetMemeber: string;
      lostPassword: string;
      password: string;
      register: string;
      rememberMe: string;
    },
    LostPassword: {
      email: string;
      send: string;
      title: string;
    },
    Menu: {
      alarm: string;
      habilitedUsers: string;
      help: string;
      logEvent: string;
      password: string;
      push: string;
      recipient: string;
      sms: string;
      signout: string;
      status: string;
      site: string;
    }
    Media: {
      mail: string;
      sms: string;
      push: string;
      alarm: string;
      notification: string;
    }
    Output: {
      label: string;
      mode_0: string;
      mode_1: string;
      temporisationUnit: string;
      temporisationValue: string;
      temporisationValueShort: string;
    }
    RecipientList: {
      confirmNotChecked: string;
      maxTenTechnicalAlarm: string;
      maxTenInputAlarm: string;
      test: string;
      title: string;
      titleEdit: string;
    },
    Register: {
      confirmation: string;
      errors: {
        confirmation: string;
      },
      register: string;
      title: string;
    },
    Schedule: {
      dateTimeTitle: string;
      dateTimeOk: string;
      dateTimeCancel: string;
      dateTimeCancelButtonLabel: string;
      dateTimeDoneButtonLabel: string;
      title: string;
      errorDayMandatory: string;
      errorStartAfterEnd: string;
      maxSchedule: string;
    }
    SiteAdd: {
      code: string;
      name: string;
      title: string;
      errorCode: string;
      errorName: string;
    },
    SiteEdit: {
      title: string;
      name: string;
      errorName: string;
    }
    Sms: {
      apnConnect: string;
      apnGet: string;
      apnPassword: string;
      apnServer: string;
      apnUser: string;
      changePassword: string;
      groupAction: string;
      groupApn: string;
      groupQuery: string;
      groupThermostat: string;
      in1: string;
      in2: string;
      info: string;
      out1off: string;
      out1on: string;
      out2off: string;
      out2on: string;
      phoneNumber: string;
      temp1: string;
      temp2: string;
      thermostatDisable: string;
      thermostatMode: string;
      title: string;
    }
    Status: {
      alreadyUptodate: string;
      appVersion: string;
      battery: string;
      battery_good: string;
      battery_medium: string;
      battery_poor: string;
      battery_unknown: string;
      sector: string;
      connectionType: string;
      disconnected: string;
      gsmNumber: string;
      gsmOperator: string;
      title: string;
      update: string;
      lastDate: string;
      mac: string;
      m1Version: string;
      m2Version: string;
      ipAddress: string;
      remoteIp: string;
    }

    Temperature: {
      label: string;
      thresholdCalibration: string;
      thresholdCalibrationShort: string;
      thresholdDelta: string;
      thresholdDeltaShort: string;
      thresholdUp: string;
      thresholdUpShort: string;
      thresholdDownShort: string;
      thresholdDown: string;
      thresholdNotCorrect: string;
      thermostat: string;
    },
    Thermostat: {
      title: string;
      modeComfort: string;
      modeEco: string;
      modeFrost: string;
      modeOff: string;
      modePlanning: string;
      planningNotAvailable: string;
      setpointComfort: string;
      setpointComfortShort: string;
      setpointEco: string;
      setpointEcoShort: string;
      setpointFrost: string;
      setpointFrostShort: string;
      setpointOrderError: string;
    };
    User: {
      lastConnection: string;
      title: string;
    }
  }
}

/**
 * Injects a i18n member to the components props
 * Must be called in the mapStateToProps of components containers
 * @param props 
 */
export function addTranslateToProps<T>(props: any): any {
  const userLang = (navigator.language || 'fr').substr(0, 2);
  if (userLang.toUpperCase() === "FR") {
    props.i18n = fr.i18n;
  }
  else if (userLang.toUpperCase() === "IT") {
    props.i18n = it.i18n;
  } else {
    props.i18n = en.i18n;
  }
  return props;
}




// WEBPACK FOOTER //
// ./src/i18n/translation.tsx